/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var MediaUiAEjectIcon16Solid = forwardRef('MediaUiAEjectIcon16Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "m2.3 8.6 4.5-6c.6-.8 1.8-.8 2.4 0l4.5 6c.742.989.036 2.4-1.2 2.4h-9c-1.236 0-1.942-1.411-1.2-2.4Z" }),
        React.createElement("path", { d: "M3 12a1 1 0 1 0 0 2h10a1 1 0 1 0 0-2H3Z" })));
});
